<template>
    <div
        class="h-full bg-white shadow-lg transition-all duration-500 ease-in-out"
        :class="{ 'w-10': isRolled, 'w-80': !isRolled }"
    >
        <div class="flex flex-col justify-start p-3 h-full">
            <div class="flex items-end">
                <dx-button
                    @click="onRollSideBar"
                    :icon="isRolled ? 'chevrondoubleright' : 'chevrondoubleleft'"
                />
            </div>
            <component ref="navigatorRef" :is="data" :isRolled="isRolled"/>
        </div>
    </div>
</template>

<script setup>
import DxButton from 'devextreme-vue/button';
import {onMounted, ref, watch} from 'vue';
import {initDisplayedNavigator} from "@/layouts/main-layout/main-layout-data";

defineProps({
    isRolled: {
        type: Boolean,
    },
});

const emit = defineEmits(['roll-side-bar']);
const data = ref();
const appId = ref();
const navigatorRef = ref();

const onRollSideBar = () => {
    emit('roll-side-bar');
};

onMounted(async () => {
    const arr = window.location.href.split('&');
    if (arr[1]) {
        appId.value = arr[1].split('/')[1];
    }

    const matchingView = viewStructure.find(item => item.kod_app === parseInt(appId.value));

    if (matchingView) {
        data.value = matchingView.view;
    }
});

watch(navigatorRef, (newRef) => {
    if (newRef) {
        initDisplayedNavigator(newRef);
    }
});

const viewStructure = [
    {kod_app: 700, view: 'navigate-menu-view'},
    {kod_app: 10, view: 'org-navigator-view'}
];
</script>
